<template>
    <div class="main">
        <a-row class="container" :gutter="0">
            <a-col :span="20" style="padding-bottom: 10px;" ref="search">
                <a-row>
                    <a-col span="6">
                        <a-input-search
                                placeholder="请输入关键字"
                                @search="onSearch"
                                enterButton
                        />
                    </a-col>
                    <a-col :span="14" style="margin-left: 20px;" v-if="!isSelectingProgressAction">
                        <a-button type="primary" @click="addReport">上报我的任务进度</a-button>
                    </a-col>
                </a-row>
            </a-col>
            <a-divider style="margin: 0;margin-bottom: 10px;"/>
            <a-col :span="24">
                <a-spin tip="加载中..." :spinning="spinning">
                    <div
                            class="demo-infinite-container"
                            v-infinite-scroll="handleInfiniteOnLoad"
                            :infinite-scroll-disabled="busy"
                            :infinite-scroll-distance="10"
                            :style="{height: listsHeight + 'px'}"
                    >
                        <a-list :dataSource="articleLists">
                            <a-list-item slot="renderItem" slot-scope="item, index" >
                                <a slot="actions" @click.stop="chooseItem(item.task_id, item.title)" v-if="isSelectingProgressAction" style="font-size: 20px;"><a-icon type="check-square" theme="twoTone" twoToneColor="red" v-if="choosedTaskId === item.task_id"/><a-icon type="border" v-else style="font-size: 20px;"/></a>
                                <a-list-item-meta :description="'最新执行进度：' + delHtmlTag(item.records[item.records.length - 1].mark)" @click="toTaskDetail(item.task_id)">
                                    <a slot="title">{{item.title}}</a>
                                    <a-avatar slot="avatar" icon="bar-chart" style="backgroundColor: #1890ff"/>
                                </a-list-item-meta>
                                <div class="desc">
                                    <p v-if="item.status == 1"><a-tag color="#f50" style="float: right;">待查看</a-tag><br/></p>
                                    <p v-else-if="item.status == 5"><a-tag color="#2db7f5" style="float: right;">已完成</a-tag><a-tag color="purple" style="float: right;" @click="toArticleDetail(item.pub_articleid)">查看此任务稿件</a-tag><br/></p>
                                    <p v-else><a-tag color="#87d068" style="float: right;">处理中</a-tag><br/></p>
                                    执行时间：{{item.records[item.records.length - 1].time}}</div>
                            </a-list-item>
                            <div v-if="loading && !busy" class="demo-loading-container">
                                <a-spin />
                            </div>
                        </a-list>
                    </div>
                </a-spin>
            </a-col>
        </a-row>
        <footer-tool-bar v-show="isSelectingProgressAction">
            <a-button type="primary" @click="goBack">确定选择</a-button>
        </footer-tool-bar>
    </div>
</template>

<script>
    import infiniteScroll from 'vue-infinite-scroll'
    import FooterToolBar from '../../components/FooterToolBar'
    import ACol from "ant-design-vue/es/grid/Col";
    const nums = 20

    function Trim (str, is_global) {
        var result
        result = str.replace(/(^\s+)|(\s+$)/g, '')
        if (is_global.toLowerCase() === 'g') {
            result = result.replace(/\s/g, '')
        }
        return result
    }
    export default {
        name: "TaskProgressList",
        components:{
            ACol,
            FooterToolBar
        },
        directives: { infiniteScroll },
        data () {
            return {
                userInfo: '',
                page: 1,
                searchValue: '',
                articleLists: [],
                loading: false,
                busy: false,
                spinning: true,
                listsHeight: 0,
                choosedTaskId: '',
                choosedTaskName: '',
                currentIndex: 0,
                footerBarHeight: 0,
                isSelectingProgressAction: false,
                isSureSelected: false,
            }
        },
        methods: {
            delHtmlTag (str) {
                var delHtmlTag = str.replace(/<[^>]+>/g, '') // 去掉所有的html标记
                return Trim(delHtmlTag, 'g')
            },
            chooseItem (id, name) {
                this.currentIndex = parseInt(id)
                this.choosedTaskName = name
                this.choosedTaskId = id
            },
            getList () {
                this.busy = true
                this.$http.post('api/assign/processlist', { page: this.page, 'executor': this.userInfo.truename, 'dept_id': this.userInfo.dept_id})
                    .then((res) => {
                        this.busy = false
                        this.spinning = false
                        this.loading = false
                        if (res.data.state === 200) {
                            if (res.data.data.length > 0) {
                                this.articleLists.push.apply(this.articleLists, res.data.data)
                                if (this.articleLists.length < nums) {
                                    this.busy = true
                                }
                            } else {
                                this.page--
                            }
                        } else {
                            this.page--
                        }
                    })
                    .catch(() => {
                        this.busy = false
                        this.spinning = false
                        this.loading = false
                        this.page--
                    })
            },
            handleInfiniteOnLoad  () {
                this.loading = true
                if (this.articleLists.length < nums) {
                    this.loading = false
                    this.busy = true
                    return
                }
                if (!this.busy) {
                    this.page++
                    this.getList()
                }
            },
            goBack () {
                this.isSureSelected = true
                this.$router.go(-1)
            },
            onSearch (value) {
                if (!this.spinning) {
                    this.searchValue = value
                    this.loading = false
                    this.busy = false
                    this.spinning = true
                    this.articleLists = []
                    this.page = 1
                    this.getList()
                }
            },
            addReport () {
                this.$router.push('/Main/Task/AddTaskProgress')
            },
            toTaskDetail (id) {
                this.$router.push({path: '/Main/Task/TaskDetail', query: {id: id}})
            },
            toArticleDetail (articleId) {
                if (articleId) {
                    this.$router.push({path: '/Main/Draft/AddArticle', query: {id: articleId}})
                } else {
                    this.$message.warning('稿件ID不存在！')
                }
            }
        },
        created() {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted() {
            this.isSureSelected = false
            this.isSelectingProgressAction = this.$store.state.isSelectingProgressAction
            if (this.isSelectingProgressAction) {
                this.footerBarHeight = 56
            }
            this.listsHeight = window.innerHeight - 92 - 40 - this.footerBarHeight - this.$refs.search.$el.clientHeight - 11// 92为顶部导航高度 地址栏高度、 40 margin距离、footerBarHeight 56 底部悬浮按钮高度 11 分割线高度
            this.getList()
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
            })
        },
        beforeRouteLeave (to, from, next) {
            if (from.path.indexOf('TaskProgressList') > -1 && (to.path.indexOf('AddTaskProgress') > -1 || to.path.indexOf('AddArticle') > -1)) {
                this.$store.commit('storeIsSelectingProgressAction', false)
                if (this.choosedTaskId && this.choosedTaskName && this.isSureSelected) {
                    if (to.path.indexOf('AddTaskProgress') > -1) {
                        this.$store.commit('storeAddProgressChoosedTaskInfo', {id: this.choosedTaskId, name: this.choosedTaskName})
                    } else if (to.path.indexOf('AddArticle') > -1) {
                        this.$store.commit('storeChoosedTaskInfo', {id: this.choosedTaskId, name: this.choosedTaskName})
                    }
                } else { // 排除未选择时 返回不改变全局变量
                }
            } else {
            }
            next()
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: #fff;
        padding-left:10px;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 20px;
        padding-left: 10px;
        padding-right: 20px;
    }
    .demo-infinite-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: auto;
        padding: 0px 24px;
        overflow-x: hidden;
    }
    .demo-loading-container {
        position: absolute;
        bottom: 40px;
        width: 100%;
        text-align: center;
    }
    .desc{
        line-height: 22px;
    }
    .desc >>> p{
        margin-bottom: 8px;
    }
    .ant-list-item-meta{
        cursor: pointer;
    }
</style>
